module.exports = __webpack_public_path__ + "static/img/bz.b3ae0614.png";